import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IAlertaPainelInterface } from '../shared/Util';
import { environment } from '../../environments/environment';
import { AlertasCardService } from '../alertas-card/alertas-card.service';
import { ObjectParam } from '../shared/interface/generic-interface';
import { NgIf } from '@angular/common';
import { DataHorarioComponent } from '../shared/componentes/data-horario/data-horario.component';
import { BotaoPrimarioComponent } from '../shared/componentes/botao-primario/botao-primario.component';



@Component({
    selector: 'app-alerta-card-notificacao',
    templateUrl: './alerta-card-notificacao.component.html',
    styleUrls: ['./alerta-card-notificacao.component.css'],
    standalone: true,
    imports: [NgIf, DataHorarioComponent, BotaoPrimarioComponent]
})
export class AlertaCardNotificacaoComponent implements OnInit {
  @Input() telaPrincipal = true;
  @Input() roteiroAlerta: IAlertaPainelInterface;
  @Input() isModal: boolean;
  @Output() abrirModalMapa = new EventEmitter<any[]>();  
  urlOcorrencias = ''


  constructor(private alertaService: AlertasCardService) { }

  ngOnInit(): void {
  }

  async abrirMaparoteiroAlerta() {
    if (this.isModal) {
      document.getElementById('btnCloseAlerta').click();
    }
    
    if (this.roteiroAlerta) { 
      this.abrirModalMapa.emit([this.roteiroAlerta.NumeroRoteiro, 0, {latitude: this.roteiroAlerta.Latitude, longitude: this.roteiroAlerta.Longitude}]);
      
      if (!this.roteiroAlerta.Visualizado) {
        let roteiroAlertaID = this.roteiroAlerta.RoteiroAlertaID;
        
        if (roteiroAlertaID) { 
          let objParam: ObjectParam = {
            roteiroAlerta: {
              RoteiroAlertaID: roteiroAlertaID
            }
          };
          await this.alertaService.updateVisualizadoAlertaRoteiro(objParam);
          
        } else {
          console.error("RoteiroAlertaID não está definido.");
        }
      }
      this.roteiroAlerta.Visualizado = true;
    } else {
      console.error("roteiroAlerta está indefinido.");
    }
  }
  

  async ocorrencia() {
    this.urlOcorrencias = environment.url_telaOcorrencias + '/index.html' + window.location.search;
  
    let idRoteiroAlerta: string;
    idRoteiroAlerta = btoa(this.roteiroAlerta.RoteiroAlertaID.toString());
   
    this.urlOcorrencias = this.urlOcorrencias + '&opc5=' + idRoteiroAlerta;
    window.open(this.urlOcorrencias, "_blank");
  
    if (!this.roteiroAlerta.Visualizado) {
      let roteiroAlertaID = this.roteiroAlerta.RoteiroAlertaID;
      let objParam: ObjectParam = {
        roteiroAlerta: {
          RoteiroAlertaID: roteiroAlertaID
        }
      };
      await this.alertaService.updateVisualizadoAlertaRoteiro(objParam);
    }
    this.roteiroAlerta.Visualizado = true;
  }

}
